export const CRUD_CREATE = 'IMP/CRUD_CREATE';
export const CRUD_CREATE_LOADING = 'IMP/CRUD_CREATE_LOADING';
export const CRUD_CREATE_FAILURE = 'IMP/CRUD_CREATE_FAILURE';
export const CRUD_CREATE_SUCCESS = 'IMP/CRUD_CREATE_SUCCESS';

export const CRUD_GET_LIST = 'IMP/CRUD_GET_LIST';
export const CRUD_GET_LIST_LOADING = 'IMP/CRUD_GET_LIST_LOADING';
export const CRUD_GET_LIST_FAILURE = 'IMP/CRUD_GET_LIST_FAILURE';
export const CRUD_GET_LIST_SUCCESS = 'IMP/CRUD_GET_LIST_SUCCESS';

export const CRUD_GET_ONE = 'IMP/CRUD_GET_ONE';
export const CRUD_GET_ONE_LOADING = 'IMP/CRUD_GET_ONE_LOADING';
export const CRUD_GET_ONE_FAILURE = 'IMP/CRUD_GET_ONE_FAILURE';
export const CRUD_GET_ONE_SUCCESS = 'IMP/CRUD_GET_ONE_SUCCESS';

export const CRUD_UPDATE = 'IMP/CRUD_UPDATE';
export const CRUD_UPDATE_LOADING = 'IMP/CRUD_UPDATE_LOADING';
export const CRUD_UPDATE_FAILURE = 'IMP/CRUD_UPDATE_FAILURE';
export const CRUD_UPDATE_SUCCESS = 'IMP/CRUD_UPDATE_SUCCESS';

export const CRUD_DELETE = 'IMP/CRUD_DELETE';
export const CRUD_DELETE_LOADING = 'IMP/CRUD_DELETE_LOADING';
export const CRUD_DELETE_FAILURE = 'IMP/CRUD_DELETE_FAILURE';
export const CRUD_DELETE_SUCCESS = 'IMP/CRUD_DELETE_SUCCESS';

export const CRUD_CUSTOM = 'IMP/CRUD_CUSTOM';
export const CRUD_CUSTOM_LOADING = 'IMP/CRUD_CUSTOM_LOADING';
export const CRUD_CUSTOM_FAILURE = 'IMP/CRUD_CUSTOM_FAILURE';
export const CRUD_CUSTOM_SUCCESS = 'IMP/CRUD_CUSTOM_SUCCESS';
